<template>
  <div>
    <vs-alert :active.sync="alert" closable icon-pack="feather" close-icon="icon-x" color="danger" title="ERROR!!!"
      style="text-align: center" @click="dismissError()">
      {{ alertMessage }}
    </vs-alert>

    <vs-alert id="alertShowNew" :active.sync="freezeLimitShow" closable icon-pack="feather" close-icon="icon-x"
      color="danger" style="text-align: left;height:40px;margin-bottom: 20px;margin-top: 20px;" @click="dismissError()">
      <div style="margin-left:10px;margin-top:10px;">{{ freezeMessage }}</div>
    </vs-alert>
    <vs-popup classContent="popup-example" title="Confirm Customer Details" :active.sync="addInvoiceSuccessFlag"
      id="addSupplierPOP">
      <div class="modal-body">
        <div class="row">
          <div style="text-align: center">
            <img src="../../assets/icons/checkcirclePOP.png" alt="login" class="mx-auto"
              style="height: 70%; padding-top: 15px" />
          </div>
          <div>
            <div style="margin-top: 20px">
              Invoice details has been added <br />
              <span style="color: #97c93e">Successfully!</span>
            </div>
          </div>
          <div style="white-space: nowrap; text-align: right; margin-right: 5px"
            @click="addInvoiceSuccessFlag = !addInvoiceSuccessFlag">
            <i class="
                vs-icon
                notranslate
                icon-scale
                vs-popup--close vs-popup--close--icon
                material-icons
                null
              " style="color: black">close</i>
          </div>
        </div>
      </div>
    </vs-popup>
    <vs-popup classContent="popup-example" title="Confirm Customer Details" :active.sync="addInvoiceFailureFlag"
      id="addSupplierPOP">
      <div class="modal-body">
        <div class="row">
          <div style="text-align: center">
            <img src="../../assets/icons/infored.png" alt="login" class="mx-auto"
              style="height: 70%; padding-top: 15px" />
          </div>
          <div>
            <div style="margin-top: 20px">
              Invoice details addition
              <span style="color: #ea5455">Failed</span>.<br />
              {{ invoiceAddError }} Please try again.
            </div>
          </div>
          <div style="white-space: nowrap; text-align: right; margin-right: 5px"
            @click="addInvoiceFailureFlag = !addInvoiceFailureFlag">
            <i class="
                vs-icon
                notranslate
                icon-scale
                vs-popup--close vs-popup--close--icon
                material-icons
                null
              " style="color: black">close</i>
          </div>
        </div>
      </div>
    </vs-popup>
    <vs-popup classContent="popup-example" title="Confirm Customer Details" :active.sync="approveInvoiceFailureFlag"
      id="addSupplierPOP">
      <div class="modal-body">
        <div class="row">
          <div style="text-align: center">
            <img src="../../assets/icons/infored.png" alt="login" class="mx-auto"
              style="height: 70%; padding-top: 15px" />
          </div>
          <div>
            <div style="margin-top: 20px">
              Create Loan
              <span style="color: #ea5455">Failed</span>.<br />
              {{ approveInvoiceAddError }} Please try again.
            </div>
          </div>
          <div style="white-space: nowrap; text-align: right; margin-right: 5px"
            @click="approveInvoiceFailureFlag = !approveInvoiceFailureFlag">
            <i class="
                vs-icon
                notranslate
                icon-scale
                vs-popup--close vs-popup--close--icon
                material-icons
                null
              " style="color: black">close</i>
          </div>
        </div>
      </div>
    </vs-popup>
    <vs-popup classContent="popup-example" title="Are You Sure You Want To Send SMS?" :active.sync="invoiceImage"
      id="addSupplierPOP">
      <div class="modal-body">
        <div class="row" style="float: right; margin-right: 0px" @click="invoiceImage = !invoiceImage">
          <i class="
              vs-icon
              notranslate
              icon-scale
              vs-popup--close vs-popup--close--icon
              material-icons
              null
            " style="background: rgb(0, 0, 0); color: white">close</i>
        </div>
        <embed :src="viewPassportImage" width="600" height="600" type="application/pdf"
          v-if="checkImageType(viewPassportImage) === 'pdf'" />
        <croppa v-model="croppa" :width="600" :height="600" class="c1" placeholder="" :show-remove-button="false"
          :initial-image="viewPassportImage" style="height: 600px; width: 600px" :disabled="true"
          :disable-click-to-choose="true" :disable-drag-to-move="true" v-else>
        </croppa>

        <!-- <v-img
          max-width="600"
          :src="viewPassportImage"
          style="margin:10px;"
        ></v-img> -->
      </div>
    </vs-popup>
    <b-modal id="modal-center-invoice" ref="modal-center-invoice" centered hide-footer title="Vertically Centered"
      cancel-title="Close" ok-title="Submit">
      <div>
        <img src="../../assets/icons/Document.png" />
        <span style="padding-left: 1rem; color: #5e5873; font-size: 24px"><b>Add Invoice</b></span>
      </div>
      <br />
      <div class="row">
        <b-form-group style="font-size: 12px" class="col-4" label="Invoice No">
          <b-form-input v-model="invoiceNumber" placeholder="Enter Invoice No" style="font-size: 12px" />
          <span style="color: #a94442; font-size: 10px">{{ invoiceNumberError }}
          </span>
        </b-form-group>
        <b-form-group style="font-size: 12px" class="col-4" label="Invoice Date">
          <div style="display: flex">
            <flat-pickr v-model="date" class="form-control" style="
                font-size: 12px;
                border-right-color: white;
                border-top-right-radius: 0px;
                border-bottom-right-radius: 0px;
              " placeholder="Select Date" />
            <div style="
                border: 1px solid #d8d6de;
                border-radius: 0.357rem;
                padding: 6px;
                border-top-left-radius: 0px;
                border-bottom-left-radius: 0px;
                border-top-right-radius: 0.357rem;
                border-bottom-right-radius: 0.357rem;
                display: flex;
              ">
              <feather-icon style="color: rgb(186, 191, 199); width: 20px" icon="CalendarIcon" />
            </div>
          </div>
          <!-- <b-form-datepicker
            id="invoice-date-datepicker"
            :date-format-options="{
              year: 'numeric',
              month: 'numeric',
              day: 'numeric',
            }"
            placeholder="Enter Invoice No"
            v-model="date"
            style="font-size:12px;"
          /> -->
          <span style="color: #a94442; font-size: 10px">{{ dateError }} </span>
        </b-form-group>
        <b-form-group style="font-size: 12px" class="col-4" label="Due Date">
          <div style="display: flex">
            <flat-pickr v-model="dueDate" class="form-control" style="
                font-size: 12px;
                border-right-color: white;
                border-top-right-radius: 0px;
                border-bottom-right-radius: 0px;
              " placeholder="Select Date" />
            <div style="
                border: 1px solid #d8d6de;
                border-radius: 0.357rem;
                padding: 6px;
                border-top-left-radius: 0px;
                border-bottom-left-radius: 0px;
                border-top-right-radius: 0.357rem;
                border-bottom-right-radius: 0.357rem;
                display: flex;
              ">
              <feather-icon style="color: rgb(186, 191, 199); width: 20px" icon="CalendarIcon" />
            </div>
          </div>
          <!-- <b-form-datepicker
            id="due-date-datepicker"
            :date-format-options="{
              year: 'numeric',
              month: 'numeric',
              day: 'numeric',
            }"
            placeholder="Enter Invoice No"
            v-model="dueDate"
            style="font-size:12px;"
          /> -->
          <span style="color: #a94442; font-size: 10px">{{ dueDateError }}
          </span>
        </b-form-group>
      </div>
      <div class="row">
        <b-form-group style="font-size: 12px" class="col-4" label="Amount">
          <b-form-input style="font-size: 12px" v-model="invoiceAmount" placeholder="Enter Amount" type="number" />
          <span style="color: #a94442; font-size: 10px">{{ invoiceAmountError }}
          </span>
        </b-form-group>
        <b-form-group class="col-4" style="font-size: 12px; padding-left: 1rem" label="Supplier">
          <v-select v-model="supplier" :options="suppliersListAssociated" placeholder="Select Supplier"
            style="font-size: 12px">
            <template slot="option" slot-scope="option">
              <span>{{ option.supplierId }} - {{ option.name }}</span>
            </template>
            <template slot="selected-option" slot-scope="option">
              <span>{{ option.supplierId }} - {{ option.name }}</span>
            </template>
          </v-select>
          <span style="color: #a94442; font-size: 10px">{{ supplierError }}
          </span>
        </b-form-group>
        <b-form-group style="font-size: 12px" class="col-4" label="Upload Invoice">
          <v-file-input placeholder="Upload" outlined dense prepend-icon="" append-icon="mdi-tray-arrow-up"
            v-on:change="uploadDocument()" v-model="invoiceImageUploadUrl" style="font-size: 12px"></v-file-input>
          <span style="color: #a94442; font-size: 10px"> </span>
        </b-form-group>
      </div>
      <div style="margin-top: 10px; text-align: right; padding-bottom: 10px">
        <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="outline-primary" style="margin-right: 5px"
          @click="hideModal()">
          Close
        </b-button>
        <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" @click="finalUploadInvoice()"
          style="margin-left: 5px; padding-left: 40px; padding-right: 40px">
          Submit
        </b-button>
      </div>
    </b-modal>
    <div>
      <b-button variant="none"
        style="background-image: linear-gradient(47deg, transparent, transparent);color: #6e6b7b;"
        :class="{ buttonActiveNew: selectedButtonN == 1 }" @click="changeActive(1)">
        Pending
      </b-button>
      <b-button variant="none"
        style="background-image: linear-gradient(47deg, transparent, transparent);color: #6e6b7b;"
        :class="{ buttonActiveNew: selectedButtonN == 2 }" @click="changeActive(2)">
        Active
      </b-button>

      <b-button variant="none"
        style="background-image: linear-gradient(47deg, transparent, transparent);color: #6e6b7b;"
        :class="{ buttonActiveNew: selectedButtonN == 3 }" @click="changeActive(3)">
        Repaid
      </b-button>

      <!-- <b-button



        variant="none"
        style="background-image: linear-gradient(47deg, transparent, transparent);color: #6e6b7b;"
        :class="{ buttonActiveNew: selectedButtonN == 4}"
        @click="changeActive(4)"
      >
        Closed
      </b-button> -->

      <b-button variant="none"
        style="background-image: linear-gradient(47deg, transparent, transparent);color: #6e6b7b;"
        :class="{ buttonActiveNew: selectedButtonN == 5 }" @click="changeActive(5)">
        Rejected
      </b-button>

      <b-button variant="none"
        style="background-image: linear-gradient(47deg, transparent, transparent);color: #6e6b7b;"
        :class="{ buttonActiveNew: selectedButtonN == 6 }" @click="changeActive(6)">
        Pre disbursement closed
      </b-button>
    </div>
    <div v-if="showLoans.length > 0">
      <vx-card v-for="(item, index) in showLoans" :key="item.loan_reference_id" class="card"
        style="height: fit-content; margin-top: 28px; width: 100%">
        <div style="display: flex">
          <span class="col-6" style="width: 20%; color: #4328ae; font-size: 15px"><b style="margin-left: -15px;">Loan -
              {{
                item.loan_reference_id }}</b></span>

          <div class="col-6" style="text-align: right">
            <div style="text-align: right;">
              <b-badge v-if="item.status == 'ACTIVE'" style="padding: 10px;
            font-size: 12px;" :style="{
              color: '#97C93E',
              background: '#EEF4E4'
            }">
                Active
              </b-badge>

              <b-badge v-if="item.status == 'CLOSED'" style="padding: 10px;
            font-size: 12px;" :style="{
              color: '#4328AE',
              background: '#E2DFEF'
            }">
                Closed
              </b-badge>

              <b-badge v-if="item.status == 'REPAID'" style="padding: 10px;
            font-size: 12px;" :style="{
              color: '#4328AE',
              background: '#E2DFEF'
            }">
                Repaid
              </b-badge>

              <b-badge v-if="item.status == 'REJECTED'" style="padding: 10px;
            font-size: 12px;" :style="{
              color: '#EA5455',
              background: '#F8E6E7'
            }">
                Rejected
              </b-badge>

              <b-badge v-if="item.status == 'PENDING'" style="padding: 10px;
            font-size: 12px;" :style="{
              color: '#FF9F43',
              background: '#F9EDE2'
            }">
                Pending
              </b-badge>

              <b-badge v-if="item.status == 'PRE_DISBURSEMENT_CLOSED'" style="padding: 10px;
            font-size: 12px;" :style="{
              color: '#FF9F43',
              background: '#F9EDE2'
            }">
                Pre disbursement closed
              </b-badge>
            </div>
          </div>
        </div>

        <hr class="hr5" style="margin-left: -1.5rem; margin-right: -1.5rem" />

        <div class="row" style="padding: 5px 0px 18px">
          <div style="width: 50%; padding-right: 1rem; padding-left: 1rem">
            <span style="color: #5e5873; font-size: 15px"><b>Loan Details</b></span>

            <div class="row" style="padding: 5px 0px 18px">
              <div style="width: 33%; padding-right: 1rem; padding-left: 1rem">
                <span style="font-size: 12px; color: #b9b9c3">Loan Id</span><br />
                <span style="font-size: 12px; color: #5e5873">
                  {{
                    item.loan_reference_id != undefined
                      ? item.loan_reference_id
                      : "__ __"
                  }}
                </span>
              </div>

              <div style="width: 33%; padding-right: 1rem; padding-left: 1rem">
                <span style="font-size: 12px; color: #b9b9c3">Invoice No.</span><br />
                <span style="font-size: 12px; color: #5e5873">
                  {{
                    item.purchase_order_number != undefined
                      ? item.purchase_order_number
                      : "__ __"
                  }}
                </span>
              </div>
              <div style="width: 33%; padding-right: 1rem; padding-left: 1rem">
                <span style="font-size: 12px; color: #b9b9c3">Loan Amount</span><br />
                <span style="font-size: 12px; color: #5e5873">
                  {{ item.principal != undefined ? item.principal : "__ __" }}
                </span>
              </div>
            </div>
            <div class="row" style="padding: 5px 0px 18px">
              <div style="width: 33%; padding-right: 1rem; padding-left: 1rem">
                <span style="font-size: 12px; color: #b9b9c3">Loan Creation Date</span><br />
                <span style="font-size: 12px; color: #5e5873">
                  {{ item.loan_request_date | moment("DD MMM YYYY") }}
                </span>
              </div>
              <div style="width: 33%; padding-right: 1rem; padding-left: 1rem">
                <span style="font-size: 12px; color: #b9b9c3">Loan Activation Date</span><br />
                <span style="font-size: 12px; color: #5e5873">
                  {{ item.loan_approval_date | moment("DD MMM YYYY") }}
                </span>
              </div>
              <div style="width: 33%; padding-right: 1rem; padding-left: 1rem">
                <span style="font-size: 12px; color: #b9b9c3">Loan Disbursal Date</span><br />
                <span style="font-size: 12px; color: #5e5873" v-if="item.loan_disbursed_date">
                  {{ item.loan_disbursed_date | moment("DD MMM YYYY") }}
                </span>
                <span style="font-size: 12px; color: #5e5873" v-else>
                  __ __
                </span>
              </div>
            </div>
            <div class="row" style="padding: 5px 0px 18px">
              <div style="width: 33%; padding-right: 1rem; padding-left: 1rem">
                <span style="font-size: 12px; color: #b9b9c3">Due Date</span><br />
                <span style="font-size: 12px; color: #5e5873" v-if="item.expected_maturity_date">
                  {{ item.expected_maturity_date | moment("DD MMM YYYY") }}
                </span>
                <span style="font-size: 12px; color: #5e5873" v-else>
                  __ __
                </span>
              </div>
              <div style="width: 33%; padding-right: 1rem; padding-left: 1rem">
                <span style="font-size: 12px; color: #b9b9c3">Disbursed Loan Amount</span><br />
                <span style="font-size: 12px; color: #5e5873">
                  {{
                    item.approved_principal != undefined &&
                      item.approved_principal.toString().length > 0
                      ? item.approved_principal.toLocaleString()
                      : "__ __"
                  }}
                </span>
              </div>
              <div style="width: 33%; padding-right: 1rem; padding-left: 1rem">
                <span style="font-size: 12px; color: #b9b9c3">Disbursal UTR No</span><br />
                <span style="font-size: 12px; color: #5e5873">
                  __ __
                </span>
              </div>
            </div>
          </div>
          <div style="width: 50%; padding-right: 1rem; padding-left: 3rem">
            <span style="color: #5e5873; font-size: 15px"><b>Current Outstanding Details</b></span>

            <div class="row" style="padding: 5px 0px">
              <div style=" padding-right: 1rem; padding-left: 1rem;text-align:left;" class="row"
                v-if="item.status == 'ACTIVE' || item.status == 'REPAID'">
                <span style="font-size: 12px; color: #b9b9c3;width: 170px;margin-left: 15px;">Total Outstanding
                  Amount</span>
                <span style="font-size: 12px; color: #5e5873;margin-left: 20px;" v-if="item.total_outstanding">
                  {{ item.total_outstanding }}
                </span>
                <span style="font-size: 12px; color: #5e5873;margin-left: 20px;" v-else>
                  __ __
                </span>
              </div>
              <div style=" padding-right: 1rem; padding-left: 1rem;text-align:left;" class="row" v-else>
                <span style="font-size: 12px; color: #b9b9c3;width: 170px;margin-left: 15px;">Total Outstanding
                  Amount</span>
                <span style="font-size: 12px; color: #5e5873;margin-left: 20px;" v-if="item.amount">
                  {{ item.amount }}
                </span>
                <span style="font-size: 12px; color: #5e5873;margin-left: 20px;" v-else>
                  __ __
                </span>
              </div>
            </div>
            <div class="row" style="padding: 5px 0px">
              <div style=" padding-right: 1rem; padding-left: 1rem;text-align:left;" class="row">
                <span style="font-size: 12px; color: #b9b9c3;width: 170px;margin-left: 15px;">Principal Amount</span>
                <span style="font-size: 12px; color: #5e5873;margin-left: 20px;" v-if="item.principal">
                  {{ item.principal }}
                </span>
                <span style="font-size: 12px; color: #5e5873;margin-left: 20px;" v-else>
                  __ __
                </span>
              </div>
            </div>
            <div class="row" style="padding: 5px 0px">
              <div style=" padding-right: 1rem; padding-left: 1rem;text-align:left;" class="row">
                <span style="font-size: 12px; color: #b9b9c3;width: 170px;margin-left: 15px;">Interest Amount</span>
                <span style="font-size: 12px; color: #5e5873;margin-left: 20px;" v-if="item.interest_protion">
                  {{ item.interest_protion }}
                </span>
                <span style="font-size: 12px; color: #5e5873;margin-left: 20px;" v-else>
                  __ __
                </span>
              </div>
            </div>

            <div class="row" style="padding: 5px 0px">
              <div style=" padding-right: 1rem; padding-left: 1rem;text-align:left;" class="row">
                <span style="font-size: 12px; color: #b9b9c3;width: 170px;margin-left: 15px;">Penalty</span>
                <span style="font-size: 12px; color: #5e5873;margin-left: 20px;" v-if="item.penalty">
                  {{ item.penalty }}
                </span>
                <span style="font-size: 12px; color: #5e5873;margin-left: 20px;" v-else>
                  __ __
                </span>
              </div>
            </div>
            <div class="row" style="padding: 5px 0px">
              <div style=" padding-right: 1rem; padding-left: 1rem;text-align:left;" class="row">
                <span style="font-size: 12px; color: #b9b9c3;width: 170px;margin-left: 15px;">Penal Interest</span>
                <span style="font-size: 12px; color: #5e5873;margin-left: 20px;">
                  __ __
                </span>
              </div>
            </div>
            <div class="row" style="padding: 5px 0px">
              <div style=" padding-right: 1rem; padding-left: 1rem;text-align:left;" class="row">
                <span style="font-size: 12px; color: #b9b9c3;width: 170px;margin-left: 15px;">Other Charges</span>
                <span style="font-size: 12px; color: #5e5873;margin-left: 20px;">
                  __ __
                </span>
              </div>
            </div>
          </div>

          <div style="width: 50%; padding-right: 1rem; padding-left: 1rem;margin-bottom:20px;"
            v-if="item.repayment_details.length > 0">
            <span style="color: #5e5873; font-size: 15px"><b>Repayment Details </b></span>
          </div>

          <b-table v-if="item.repayment_details.length > 0" ref="selectableTable" selectable striped hover responsive
            :per-page="perPage" :current-page="currentPage" :items="item.repayment_details" :fields="fieldsNew"
            :sort-by.sync="sortBy" id="repayTable">
            <template #cell(transaction_ref_no)="data">
              <h5 style="font-size: 12px;" v-if="data.value != ''">
                <b>{{ data.value }}</b>
              </h5>

              <span style="white-space: nowrap" v-else>__ __</span>
            </template>

            <template #cell(amount)="data">
              <span style="font-size: 12px;" v-if="data.value != ''">{{
                data.value
                }}</span>

              <span style="white-space: nowrap" v-else>__ __</span>
            </template>
            <template #cell(status)="data">
              <span style="font-size: 12px;color:#97C93E" v-if="data.value === 'PASS'">SUCCESS</span>
              <span style="font-size: 12px;color:#FF9F43" v-else-if="data.value === 'SUBMITTED'">PENDING</span>

              <span style="white-space: nowrap" v-else>__ __</span>
            </template>

            <template #cell(transaction_date)="data">
              <span style="font-size: 12px;" v-if="data.value != ''">{{
                data.value
                }}</span>

              <span style="white-space: nowrap" v-else>__ __</span>
            </template>
            <template #cell(mode_of_payment)="data">
              <span style="font-size: 12px;" v-if="data.value != ''">Online Payment</span>

              <span style="white-space: nowrap" v-else>__ __</span>
            </template>

            <template #cell(payment_app)="data">
              <span style="font-size: 12px;" v-if="data.value != ''">{{
                data.value
                }}</span>

              <span style="white-space: nowrap" v-else>__ __</span>
            </template>
          </b-table>
        </div>
      </vx-card>
    </div>

    <div v-else>
      <vx-card style="margin-top: 28px;height: fit-content;">
        <b-row style="align-items: center;margin-left: 35%;">
          <div v-if="selectedButtonN === 1">
            <img src="../../assets/icons/noPendingLoans.png" alt="login" class="mx-auto" style="height:60%;width:60%" />
          </div>
          <div style="" v-else-if="selectedButtonN === 2">
            <img src="../../assets/icons/noactiveLoans.png" alt="login" class="mx-auto" style="height:60%;width:60%" />
          </div>
          <div style="" v-else-if="selectedButtonN === 3">
            <img src="../../assets/icons/noClosedLoans.png" alt="login" class="mx-auto" style="height:60%;width:60%" />
          </div>
          <div style="" v-else-if="selectedButtonN === 4">
            <img src="../../assets/icons/noRejectedLoans.png" alt="login" class="mx-auto"
              style="height:60%;width:60%" />
          </div>
          <div style="" v-else-if="selectedButtonN === 5">
            <img src="../../assets/icons/noRejectedLoans.png" alt="login" class="mx-auto"
              style="height:60%;width:60%" />
          </div>

          <div class="col-7" v-if="selectedButtonN === 1">
            <span style="font-size: 18px; color: #5e5873; font-weight: 500">
              No Pending Loan details available
            </span>
          </div>
          <div class="col-7" v-else-if="selectedButtonN === 2">
            <span style="font-size: 18px; color: #5e5873; font-weight: 500">
              No Active Loan details available
            </span>
          </div>
          <div class="col-7" v-else-if="selectedButtonN === 3">
            <span style="font-size: 18px; color: #5e5873; font-weight: 500">
              No Repaid Loan details available
            </span>
          </div>
          <div class="col-7" v-else-if="selectedButtonN === 4">
            <span style="font-size: 18px; color: #5e5873; font-weight: 500">
              No Closed Loan details available
            </span>
          </div>
          <div class="col-7" v-else-if="selectedButtonN === 5">
            <span style="font-size: 18px; color: #5e5873; font-weight: 500">
              No Rejected Loan details available
            </span>
          </div>
        </b-row>
      </vx-card>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { BRow, BCol, BFormRadio, BCard, BCardText } from "bootstrap-vue";
import vSelect from "vue-select";
import ToastificationContent from "../../@core/components/toastification/ToastificationContent.vue";
import Ripple from "vue-ripple-directive";
import flatPickr from "vue-flatpickr-component";
import VuePDFViewer from "vue-instant-pdf-viewer";

export default {
  data() {
    return {
      approveInvoiceFailureFlag: false,
      approveInvoiceAddError: "",
      invoiceApproveAmountError: [],
      invoiceApproveAmount: [],
      invoiceList: [],
      finacePlaList: [],
      alert: false,
      alertMessage: "",
      fields: [
        {
          key: "financingPlanId",
          label: "PLAN ID"
        },
        {
          key: "planName",
          label: "PLAN NAME"
        },
        {
          key: "discountRate",
          label: "DISCOUNT RATE"
        },
        {
          key: "fldgPercentage",
          label: "HOLDBACK RATE"
        },
        {
          key: "delayedDisbursementDays",
          label: "DELAYED DISBURSAL"
        }
      ],
      addInvoiceFailureFlag: false,
      addInvoiceSuccessFlag: false,
      invoiceImageUploadUrl: null,
      invoiceAddError: "",
      secondDocument: null,
      borrowerId: 0,
      borrowerId: 0,
      mobileNumber: 0,
      companyName: "",
      invoiceNumber: "",
      invoiceAmount: "",
      supplier: null,
      date: null,
      dueDate: null,
      invoiceUrl: null,
      invoiceImage: null,
      invoiceUrlSecond: null,

      invoiceNumberError: "",
      invoiceAmountError: "",
      dateError: null,
      dueDateError: null,
      invoiceImageError: null,
      supplierError: "",
      customerId: 0,
      showPassportFontPop: false,
      viewPassportImage: null,
      suppliersListAssociated: [],
      croppa: {},
      invoiceAddError: "",
      financePlan: "",
      loanID: 56,
      termFrequency: "",
      repayEvery: "",
      defaultInterestRate: "",
      interestRatePerPeriod: "",
      frontPubLocation: "",
      frontPubLocationSecond: "",
      invoiceIdSelected: 0,
      companyName: "",
      loanInfo: [],
      totalLimit: 0,
      availableLimit: 100000,
      utilizedLimit: 0,
      avilablePercentage: 0,
      program: "",
      razorpayAccountId: "",
      getFinancingPlanSupplierMappingDetails: [],
      mappingID: "",
      limitFreeze: false,
      freezeLimitShow: false,
      freezeMessage: "",
      iscashbackFlag: false,
      setProfileId: "",
      selectedButtonN: 1,
      pendingLoans: [],
      closedLoans: [],
      activeLoans: [],
      showLoans: [],
      rejectedLoans: [],
      repaidLoans: [],
      preClosedLoans: [],
      fieldsNew: [
        {
          key: "transaction_ref_no",
          label: "TRANSACTION ID",
          sortable: true,
          thClass: "text-left"
        },
        {
          key: "amount",
          label: "AMOUNT",
          sortable: true
        },
        { key: "status", label: "STATUS", sortable: true },
        { key: "transaction_date", label: "CREATED AT", sortable: true },
        { key: "mode_of_payment", label: "MODE", sortable: true },
        { key: "payment_app", label: "SOURCE", sortable: true }
      ]
    };
  },
  components: {
    BRow,
    BCol,
    BFormRadio,
    BCardText,
    BCard,
    ToastificationContent,

    vSelect,
    flatPickr,
    "vue-pdf-viewer": VuePDFViewer
  },
  created() {
    this.$store.commit("routeChange", "end");
    this.DashboardApi();
    this.changeActive(this.selectedButtonN);
  },
  directives: {
    Ripple
  },
  methods: {
    changeActive(value) {
      this.selectedButtonN = value;
      this.showLoans = [];
      if (this.selectedButtonN === 1) {
        this.showLoans = this.pendingLoans;
      } else if (this.selectedButtonN === 2) {
        this.showLoans = this.activeLoans;
      } else if (this.selectedButtonN === 3) {
        this.showLoans = this.repaidLoans;
      }
      // else if(this.selectedButtonN === 4)
      // {
      //   this.showLoans = this.closedLoans
      // }
      else if (this.selectedButtonN === 5) {
        this.showLoans = this.rejectedLoans;
      } else if (this.selectedButtonN === 6) {
        this.showLoans = this.preClosedLoans;
      }
      console.log("this is the loan detausls to show", this.showLoans.length);
    },
    showError() {
      this.freezeLimitShow = true;
      this.freezeMessage =
        "Invoice can not be uploaded as limit is freezed for this customer";
    },
    showApproveError() {
      this.freezeLimitShow = true;
      this.freezeMessage =
        "Approval of invoice is not possible as limit is freezed for this customer";
    },
    showCreateLoanError() {
      this.freezeLimitShow = true;
      this.freezeMessage =
        "Loan creation is not possible as limit is freezed for the customer";
    },
    freezeStatus() {
      var custId = [this.$route.query.data];
      this.$store.commit("routeChange", "start");
      let self = this;
      let data = { customerIds: custId };
      let url =
        "https://uatgateway.supermoney.in/credit-analytics-service/customer/limit/status";
      axios
        .post(url, data, {
          headers: {
            "content-type": "application/json"
          }
        })
        .then(function (response) {
          const JSONData = response.data;
          if (JSONData.status[0].limitStatus === "FREEZE") {
            // self.showContactDetailsAvail = true
            // self.getContactDetails()
            self.limitFreeze = true;
          } else {
            self.limitFreeze = false;
          }
        })
        .catch(function (error) {
          // handle error
          console.log("display  ==" + error);
        })
        .finally(function () {
          // always executed
          self.$store.commit("routeChange", "end");
        });
    },
    getColorCode(status) {
      if (status == "PENDING" || status == "REQUESTED") {
        return "#FF9F43";
      } else if (status == "ACTIVE" || status == "APPROVED") {
        return "#97C93E";
      } else if (status == "REJECTED") {
        return "#EA5455";
      } else {
        return "#4328AE";
      }
    },
    fetchApplicationId() {
      this.$store.commit("routeChange", "start");
      let self = this;

      let url =
        "https://uatgateway.supermoney.in/supermoney-service/customer/application/get";
      let request = {
        customerId: self.$route.query.data,
        applicationId: self.$route.query.applicationId
      };

      axios
        .post(url, request, {
          headers: {
            "content-type": "application/json"
          }
        })
        .then(function (response) {
          self.$store.commit("routeChange", "end");
          console.log(response);
          const JSONData = response.data;
          self.setProfileId =
            JSONData.getCustomerApplicationResponseList[0].profileId;
          self.program =
            JSONData.getCustomerApplicationResponseList[0].programDetails;
        })
        .catch(function (error) {
          // handle error
          console.log("display  ==" + error);
        })
        .finally(function () {
          //self.$store.commit("routeChange", "end");
        });
    },
    checkLoanCreated(invoiceId) {
      let loan = this.loanInfo.filter(item => item.related_id == invoiceId);

      return loan.length > 0;
    },
    listLoan() {
      var timestamp = Math.round(+new Date() / 1000);
      var userip = this.$store.getters.ipAddress;
      const instance = axios.create({
        baseURL: "https://uatgateway.supermoney.in/loanService/",

        headers: { "content-type": "application/json" }
      });
      var data = {
        customer_id: Number(this.$route.query.data),
        application_id: Number(this.$route.query.applicationId)
      };
      var msgHeader = {
        authToken: localStorage.getItem("authtoken"), //dynamic
        authLoginID: this.$store.getters.loginId,
        timestamp: timestamp,
        ipAddress: userip
      };
      var employeeKycDetails = { data, msgHeader };
      instance
        .post("LoanMaster", data)
        .then(response => {
          const JSONData = response.data;
          if (JSONData.error_code == "") {
            this.loanInfo = JSONData.data;
            this.DashboardApi();
          } else if (JSONData.msgHeader.authToken === "") {
            this.error = JSONData.data.message;
          } else {
            this.error = JSONData.data.message;
            this.errorText = JSONData.data.message;
          }
          this.$store.commit("routeChange", "end");

          this.progress = false;
        })
        .catch(error => {
          this.errorText = "Network Error";
          console.log("display Error" + error);
          this.$store.commit("routeChange", "end");
        });
    },
    chooseFiles(item) {
      this.invoiceIdSelected = item.invoiceId;
      let input = document.getElementById("secondUpload");
      input.click();
    },
    checkImageType(url) {
      console.log("this is the url", url);
      if (url) {
        let breakDown = url.split(".");
        return breakDown[breakDown.length - 1];
      }
    },
    rejectInvoice(item) {
      var self = this;
      self.$store.commit("routeChange", "start");

      const instance = axios.create({
        baseURL:
          "https://uatgateway.supermoney.in/invoice-finance-services/invoice-services/finance/invoices/",

        headers: { "content-type": "application/json" }
      });
      var data = {
        invoiceId: item.invoiceId,
        rejectReason: "Rejected By " + self.$store.getters.loginId,
        companyName: self.companyName
      };
      instance
        .post("reject", data)

        .then(function (response) {
          console.log(response);
          const JSONData = response.data;

          if (JSONData.status === true) {
            self.$store.commit("routeChange", "end");
            self.listLoan();
            self.sendRejectSMS(
              item,
              "Rejected By " + self.$store.getters.loginId
            );
          } else {
            self.GeneralError = true;
            self.errorMessage = "Invalid Details";
            self.$store.commit("routeChange", "end");
          }
        })
        .catch(function (error) {
          if (error.response) {
            console.log(error.response.data);
            console.log(error.response.status);
            console.log(error.response.headers);
            self.GeneralError = true;
            self.errorMessage = error.response.data.errors[0];
            self.$store.commit("routeChange", "end");
          }
        });
    },
    getLoanId(item) {
      var self = this;

      for (
        var i = 0;
        i < this.getFinancingPlanSupplierMappingDetails.length;
        i++
      ) {
        if (
          this.getFinancingPlanSupplierMappingDetails[i].supplierId ===
          item.supplierDetails.supplierId
        ) {
          this.iscashbackFlag = true;
        }
      }

      //if (
      //  this.getFinancingPlanSupplierMappingDetails != null ||
      //  !this.program.isCashbackAvailable
      //) {
      // this.$store.commit("routeChange", "start");
      // var url =
      //   "https://uatgateway.supermoney.in/loanService/InvoiceLoanLMSPorting/?retailer_code=" +
      //   item.borrowerId +
      //   "&distributor_code=" +
      //   item.supplierDetails.supplierId +
      //   "&invoiceId=" +
      //   item.invoiceId;
      // axios
      //   .get(url)
      //   .then(function (response) {
      //
      //
      //     const JSONData = response.data;
      //
      //     if (JSONData.successFlag === true) {
      //       self.approveInvoice(JSONData.data[0].loan_id, item);
      //     } else {
      //       if (
      //         JSONData.errorDetails.errorMessage ===
      //         "loan is not in requested state"
      //       ) {
      //         self.loanIDSet = JSONData.data[0].loan_id;
      //         self.selectFundFlag = false;
      //         self.approveInvoice();
      //       } else {
      //         self.addInvoiceFailureFlag = true;
      //         self.invoiceAddError = JSONData.errorDetails.errorMessage;
      //
      //         self.$store.commit("routeChange", "end");
      //       }
      //     }
      //   })
      //   .catch(function (error) {
      //     // handle error
      //     console.log("display  ==" + error);
      //     self.$store.commit("routeChange", "end");
      //   })
      //   .finally(function () {
      //     // always executed
      //     self.$store.commit("routeChange", "end");
      //   });

      if (
        this.program.isCashbackAvailable === true &&
        this.iscashbackFlag === true
      ) {
        var self = this;
        self.$store.commit("routeChange", "start");
        const instance = axios.create({
          baseURL: " https://uatgateway.supermoney.in/supermoneylms/",

          headers: { "content-type": "application/json" }
        });
        var data = {
          retailer_code: item.borrowerId,
          distributor_code: item.supplierDetails.supplierId,
          invoiceId: item.invoiceId,
          customerId: Number(self.$route.query.data),
          profileId: Number(self.setProfileId),
          applicationId: Number(self.$route.query.applicationId)
        };
        instance
          .post("InvoiceLoanLMSPorting", data)

          .then(function (response) {
            console.log(response);
            const JSONData = response.data;

            if (JSONData.successFlag === true) {
              self.approveInvoice(JSONData.data[0].loan_id, item);
              self.sendApproveSMS(item);
            } else {
              if (
                JSONData.errorDetails.errorMessage ===
                "loan is not in requested state"
              ) {
                self.loanIDSet = JSONData.data[0].loan_id;
                self.selectFundFlag = false;
                self.approveInvoice();
              } else {
                self.addInvoiceFailureFlag = true;
                self.invoiceAddError = JSONData.errorDetails.errorMessage;

                self.$store.commit("routeChange", "end");
              }
            }
            self.$store.commit("routeChange", "end");
          })
          .catch(function (error) {
            if (error.response) {
              console.log(error.response.data);
              console.log(error.response.status);
              console.log(error.response.headers);
              if (error.response.data.data[0].loan_id != "") {
                self.loanIDSet = error.response.data.data[0].loan_id;
                self.selectFundFlag = false;
                self.approveInvoice(error.response.data.data[0].loan_id, item);
                self.sendApproveSMS(item);
              } else {
                self.addInvoiceFailureFlag = true;
                self.invoiceAddError =
                  error.response.data.errorDetails.errorMessage;

                self.$store.commit("routeChange", "end");
              }

              self.$store.commit("routeChange", "end");
            }
            self.$store.commit("routeChange", "end");
          });
      } else if (this.program.isCashbackAvailable === false) {
        var self = this;
        self.$store.commit("routeChange", "start");
        const instance = axios.create({
          baseURL: " https://uatgateway.supermoney.in/supermoneylms/",

          headers: { "content-type": "application/json" }
        });
        var data = {
          retailer_code: item.borrowerId,
          distributor_code: item.supplierDetails.supplierId,
          invoiceId: item.invoiceId,
          customerId: Number(self.$route.query.data),
          profileId: Number(self.setProfileId),
          applicationId: Number(self.$route.query.applicationId)
        };
        instance
          .post("InvoiceLoanLMSPorting", data)

          .then(function (response) {
            console.log(response);
            const JSONData = response.data;

            if (JSONData.successFlag === true) {
              self.approveInvoice(JSONData.data[0].loan_id, item);
              self.sendApproveSMS(item);
            } else {
              if (
                JSONData.errorDetails.errorMessage ===
                "loan is not in requested state"
              ) {
                self.loanIDSet = JSONData.data[0].loan_id;
                self.selectFundFlag = false;
                self.approveInvoice();
              } else {
                self.addInvoiceFailureFlag = true;
                self.invoiceAddError = JSONData.errorDetails.errorMessage;

                self.$store.commit("routeChange", "end");
              }
            }
            self.$store.commit("routeChange", "end");
          })
          .catch(function (error) {
            if (error.response) {
              console.log(error.response.data);
              console.log(error.response.status);
              console.log(error.response.headers);

              if (error.response.data.data[0].loan_id != "") {
                self.loanIDSet = error.response.data.data[0].loan_id;
                self.selectFundFlag = false;
                self.approveInvoice(error.response.data.data[0].loan_id, item);
                self.sendApproveSMS(item);
              } else {
                self.addInvoiceFailureFlag = true;
                self.invoiceAddError =
                  error.response.data.errorDetails.errorMessage;

                self.$store.commit("routeChange", "end");
              }

              self.$store.commit("routeChange", "end");
            }
            self.$store.commit("routeChange", "end");
          });
      } else {
        console.log("this is third step");
        this.freezeLimitShow = true;
        this.freezeMessage = "Map Supplier to a Financing plan";
      }
    },
    fetchApplicationFinancePlan() {
      this.$store.commit("routeChange", "start");
      let self = this;

      let url =
        "https://uatgateway.supermoney.in/supermoney-service/application/finance/get";
      let request = {
        applicationId: self.$route.query.applicationId
      };

      axios
        .post(url, request, {
          headers: {
            "content-type": "application/json"
          }
        })
        .then(function (response) {
          self.$store.commit("routeChange", "end");
          console.log(response);
          const JSONData = response.data;
          self.financePlan = JSONData.getApplicationFinancePlanMappingResp[0];
          self.loanID = self.financePlan.financePlanDetails.loanProductId;
          self.termFrequency = self.financePlan.financePlanDetails.repayEvery;
          self.repayEvery = self.financePlan.financePlanDetails.repayEvery;
          self.defaultInterestRate =
            self.financePlan.financePlanDetails.interestRate;
          self.razorpayAccountId =
            self.financePlan.financePlanDetails.razorpayAccountId;

          self.getFinancingPlanSupplierMappingDetails =
            JSONData.getApplicationFinancePlanMappingResp[0].getFinancingPlanSupplierMappingDetails;
          // if(self.getFinancingPlanSupplierMappingDetails)
          // {
          //   self.mappingID = self.getFinancingPlanSupplierMappingDetails.supplierId
          // }
        })
        .catch(function (error) {
          // handle error
          console.log("display  ==" + error);
          self.financePlan = {
            applicationId: 655765,
            validTill: "2024-12-30T18:30:00.000+00:00",
            financePlanDetails: {
              financingPlanId: 65,
              financingPlanName: "RealMe Final",
              description: "Final Test",
              programId: 26,
              lender: "GETCLARITY2",
              lenderDescription: "",
              isDefault: true,
              loanProductId: 56,
              loanCategory: "Buy Now Pay Later",
              loanType: "INVOICE_LIMIT",
              interestRate: 18.0,
              interestRatePerAnnum: 18.0,
              tenure: 30.0,
              tenurePeriod: "Days",
              defaultAmount: 1000000.0,
              minimumAmount: 100000.0,
              maximumAmount: 5000000.0,
              numberOfRepayments: 1,
              repayEvery: 30,
              repayEveryPeriod: "Days",
              interestFreeTerm: 0,
              interestFreePeriod: "Days",
              processingFee: 0.3,
              processingFeeType: "ApprovedCreditLimit",
              penalInterest: 0.1,
              penalInterestPeriod: "Days",
              validTill: "2024-12-31",
              createdBy: "admin@mintloan.com"
            }
          };
          self.loanID = self.financePlan.financePlanDetails.loanProductId;
          self.termFrequency = self.financePlan.financePlanDetails.repayEvery;
          self.repayEvery = self.financePlan.financePlanDetails.repayEvery;
          self.defaultInterestRate =
            self.financePlan.financePlanDetails.interestRate;
        })
        .finally(function () {
          //self.$store.commit("routeChange", "end");
        });
    },
    approveInvoice(loanId, item) {
      console.log("===" + this.getFinancingPlanSupplierMappingDetails);
      console.log("===" + this.program.isCashbackAvailable);
      for (
        var i = 0;
        i < this.getFinancingPlanSupplierMappingDetails.length;
        i++
      ) {
        if (
          this.getFinancingPlanSupplierMappingDetails[i].supplierId ===
          item.supplierDetails.supplierId
        ) {
          this.iscashbackFlag = true;
        }
      }

      if (
        this.program.isCashbackAvailable === true &&
        this.iscashbackFlag === true
      ) {
        console.log("this is first step");

        var self = this;
        self.$store.commit("routeChange", "start");
        const instance = axios.create({
          baseURL:
            "https://uatgateway.supermoney.in/invoice-finance-services/invoice-services/finance/invoices/",

          headers: { "content-type": "application/json" }
        });
        var data = {
          invoiceId: item.invoiceId,
          supplierId: item.supplierDetails.supplierId,
          borrowerId: item.borrowerId,
          companyName: item.companyName,
          loanId: loanId
        };
        instance
          .post("approve", data)

          .then(function (response) {
            console.log(response);
            const JSONData = response.data;

            if (JSONData.status === true) {
              self.updateInvoiceLoanDetails(item.invoiceId);
              self.sendApproveSMS(item);
            } else {
              self.addInvoiceFailureFlag = true;
              self.invoiceAddError = JSONData.errorDetails.errorMessage;
              self.$store.commit("routeChange", "end");
            }
            self.$store.commit("routeChange", "end");
          })
          .catch(function (error) {
            if (error.response) {
              console.log(error.response.data);
              console.log(error.response.status);
              console.log(error.response.headers);
              self.GeneralError = true;
              self.errorMessage = error.response.data.errors[0];
              self.$store.commit("routeChange", "end");
            }
            self.$store.commit("routeChange", "end");
          });
      } else if (this.program.isCashbackAvailable === false) {
        console.log("this is second step");
        var self = this;
        self.$store.commit("routeChange", "start");
        const instance = axios.create({
          baseURL:
            "https://uatgateway.supermoney.in/invoice-finance-services/invoice-services/finance/invoices/",

          headers: { "content-type": "application/json" }
        });
        var data = {
          invoiceId: item.invoiceId,
          supplierId: item.supplierDetails.supplierId,
          borrowerId: item.borrowerId,
          companyName: item.companyName,
          loanId: loanId
        };
        instance
          .post("approve", data)

          .then(function (response) {
            console.log(response);
            const JSONData = response.data;

            if (JSONData.status === true) {
              self.updateInvoiceLoanDetails(item.invoiceId);
              self.sendApproveSMS(item);
            } else {
              self.addInvoiceFailureFlag = true;
              self.invoiceAddError = JSONData.errorDetails.errorMessage;
              self.$store.commit("routeChange", "end");
            }
            self.$store.commit("routeChange", "end");
          })
          .catch(function (error) {
            if (error.response) {
              console.log(error.response.data);
              console.log(error.response.status);
              console.log(error.response.headers);
              self.GeneralError = true;
              self.errorMessage = error.response.data.errors[0];
              self.$store.commit("routeChange", "end");
            }
            self.$store.commit("routeChange", "end");
          });
      } else {
        console.log("this is third step");
        this.freezeLimitShow = true;
        this.freezeMessage = "Map Supplier to a Financing plan";
      }
    },
    dismissPOPPassportFront() {
      this.showPassportFontPop = false;
    },
    openInvoice(url) {
      this.viewPassportImage = url;
      this.invoiceImage = true;
      this.croppa.refresh();
    },
    downloadInvoice(urlSet) {
      const axiosWithoutAuth = axios.create({
        baseURL: "https://uatgateway.supermoney.in/python/" // Set the baseURL for these requests
      });

      axiosWithoutAuth.defaults.headers = {
        "content-type": "application/x-www-form-urlencoded"
      };
      var documentUrl = urlSet;
      let breakDown = urlSet.split(".");
      console.log(urlSet);
      let config = {
        // example url
        url: urlSet,
        method: "GET",
        responseType: "blob"
      };
      axiosWithoutAuth(config).then(response => {
        let routeData = response.config.url;

        axiosWithoutAuth({
          url: routeData,
          method: "GET",
          responseType: "blob"
        }).then(response => {
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement("a");

          fileLink.href = fileURL;
          if (breakDown[breakDown.length - 1] === "pdf") {
            fileLink.setAttribute("download", "file.pdf");
          } else {
            fileLink.setAttribute("download", "file.jpg");
          }

          document.body.appendChild(fileLink);

          fileLink.click();
          this.$store.commit("routeChange", "end");
        });

        //this.src = response.config.url;
      });
    },
    getDate(date) {
      return this.$moment(date).format("DD MMM YYYY");
    },
    sendApproveSMS(item) {
      var numbers = [];
      var obj = {
        mobileNumber: this.mobileNumber,
        customerId: Number(this.$route.query.data),
        smsParameters: [
          item.borrowerName,
          item.companyName,
          item.approvedInvoiceAmount
        ]
      };

      numbers.push(obj);

      console.log("this is the values", numbers);
      var self = this;

      const instance = axios.create({
        // baseURL: 'https://cors-anywhere.herokuapp.com/http://13.126.29.47:8080/mintLoan/mintloan/', //LIVE
        baseURL: "https://uatgateway.supermoney.in/mintLoan/mintloan/",
        // baseURL: 'https://cors-anywhere.herokuapp.com/https://uatgateway.supermoney.in/mintLoan/mintloan/', //DEV
        // baseURL: 'https://cors-anywhere.herokuapp.com/https://uatgateway.supermoney.in/mintLoan/mintloan/', //live
        headers: { "content-type": "application/json" }
      });

      //  var url = 'http://13.126.28.53:8080/MintReliance/MintReliance/kycCheck'
      var data = {
        smsType: "Invoice_Approve",
        language: "English",
        sendBy: "Admin",
        MobNumbersDetails: numbers
      };
      instance
        .post("sendSmsToMultipleNumbers", data)

        .then(function (response) {
          console.log(response);
          const JSONData = response.data;
          if (JSONData.successFlag === true) {
            // self.additionalPOBSet ()
            // self.additionalPOBFetch()

            self.$store.commit("routeChange", "end");
          } else {
            self.errorText = JSONData.kaleyraError;
            console.log("display Error" + JSONData.kaleyraError);
          }
          self.$store.commit("routeChange", "end");
          self.progress = false;
        })
        .catch(error => {
          self.errorText = "Network Error";
          console.log("display Error" + error);
          self.$store.commit("routeChange", "end");
        });
    },
    sendRejectSMS(item, rejectReason) {
      var numbers = [];
      var obj = {
        mobileNumber: this.mobileNumber,
        customerId: Number(this.$route.query.data),
        smsParameters: [
          item.borrowerName,
          item.companyName,
          item.invoiceAmount,
          rejectReason
        ]
      };

      numbers.push(obj);

      console.log("this is the values", numbers);
      var self = this;

      const instance = axios.create({
        // baseURL: 'https://cors-anywhere.herokuapp.com/http://13.126.29.47:8080/mintLoan/mintloan/', //LIVE
        baseURL: "https://uatgateway.supermoney.in/mintLoan/mintloan/",
        // baseURL: 'https://cors-anywhere.herokuapp.com/https://uatgateway.supermoney.in/mintLoan/mintloan/', //DEV
        // baseURL: 'https://cors-anywhere.herokuapp.com/https://uatgateway.supermoney.in/mintLoan/mintloan/', //live
        headers: { "content-type": "application/json" }
      });

      //  var url = 'http://13.126.28.53:8080/MintReliance/MintReliance/kycCheck'
      var data = {
        smsType: "Invoice_Reject",
        language: "English",
        sendBy: "Admin",
        MobNumbersDetails: numbers
      };
      instance
        .post("sendSmsToMultipleNumbers", data)

        .then(function (response) {
          console.log(response);
          const JSONData = response.data;
          if (JSONData.successFlag === true) {
            // self.additionalPOBSet ()
            // self.additionalPOBFetch()

            self.$store.commit("routeChange", "end");
          } else {
            self.errorText = JSONData.kaleyraError;
            console.log("display Error" + JSONData.kaleyraError);
          }
          self.$store.commit("routeChange", "end");
          self.progress = false;
        })
        .catch(error => {
          self.errorText = "Network Error";
          console.log("display Error" + error);
          self.$store.commit("routeChange", "end");
        });
    },
    uploadDocument() {
      if (this.invoiceImageUploadUrl != null) {
        this.alert = false;
        this.$store.commit("routeChange", "start");
        var url =
          "https://uatgateway.supermoney.in//mintLoan/mintloan/uploadFile";
        let formData = new FormData();
        formData.append("file", this.invoiceImageUploadUrl);
        formData.append(
          "data",
          '{"custid":"407", "filetype":"OTHER", "filename":"' +
          this.invoiceImageUploadUrl.name +
          '", "access": "PRIVATE"}'
        );
        formData.append(
          "msgHeader",
          '{ "loginId":"' +
          this.mobileNumber +
          '","consumerId":"414", "authToken":"' +
          localStorage.getItem("authtoken") +
          '","channelType":"M","deviceId":"SwiggyLoans","source":"WEB"}'
        );

        axios
          .post(url, formData, {
            headers: {
              "Content-Type": "multipart/form-data"
            }
          })
          .then(response => {
            const JSONData = response.data;
            var successFlag = JSONData.data.successFlag;

            if (successFlag === true) {
              this.invoiceUrl = JSONData.data.fileLocation;
              this.frontPubLocation = JSONData.data.pubFileLocation;

              this.uploadStatus();
            } else {
              if (JSONData.header.hostStatus === "E") {
                this.errorAadharImg = true;

                this.errorAadharImgText = JSONData.header.error.errorDesc;
                if (JSONData.header.error.errorDesc === "") {
                  this.errorAadharImgText =
                    JSONData.data.errorDetails.errorDesc;
                }
              } else {
                this.errorAadharImg = true;
                this.errorAadharImgText =
                  JSONData.data.errorDetails[0].errorDesc;
              }
              this.$store.commit("routeChange", "end");
            }
            // this.$store.commit("routeChange", "end");
          })
          .catch(function (error) {
            console.log(error);
          });
      } else {
        this.uploadAddressFlag = true;
        this.uploadAddressMessage = "Please select file";
      }
    },

    uploadStatus() {
      var self = this;
      self.$store.commit("routeChange", "start");
      console.log("this is pan no", self.panno);
      const instance = axios.create({
        baseURL: "https://uatgateway.supermoney.in/mintLoan/mintloan/",
        headers: { "content-type": "application/json" }
      });

      //  var url = 'http://13.126.28.53:8080/MintReliance/MintReliance/kycCheck'
      var data = {
        profileId: self.profileId,
        documentDetails: [
          {
            docSeqId: "",
            docStatus: "N",
            docTypeId: "126",
            docURL: self.invoiceUrl,
            applicationId: this.$route.query.applicationId
          }
        ]
      };
      var timestamp = Math.round(+new Date() / 1000);
      var msgHeader = {
        authToken: localStorage.getItem("authtoken"), //dynamic
        loginId: self.mobileNumber,
        channelType: "M",
        consumerId: "414",
        deviceId: "SwiggyLoans",
        source: "webDirect"
      };
      var deviceFPmsgHeader = {
        clientIPAddress: "192.168.0.122",
        connectionMode: "WIFI",
        country: "United States",
        deviceManufacturer: "Xiaomi",
        deviceModelNo: "Mi A2",
        dualSim: false,
        imeiNo: "09d9212a07553637",
        latitude: "",
        longitude: "",
        nwProvider: "xxxxxxxx",
        osName: "Android",
        osVersion: 28,
        timezone: "Asia/Kolkata",
        versionCode: "58",
        versionName: "5.5.1"
      };

      var employeeDetails = { data, deviceFPmsgHeader, msgHeader };
      instance
        .post("kycDocumentUploadStatus", employeeDetails)

        .then(function (response) {
          console.log(response);
          const JSONData = response.data;
          if (JSONData.data.successFlag == true) {
            // self.documentGroup()
            self.invoiceUrl;
          }
          self.$store.commit("routeChange", "end");

          self.progress = false;
        })
        .catch(error => {
          self.errorText = "Network Error";
          console.log("display Error" + error);
          self.$store.commit("routeChange", "end");
        });
    },
    uploadDocumentSecond() {
      if (this.secondDocument != null) {
        this.alert = false;
        this.$store.commit("routeChange", "start");
        var url =
          "https://uatgateway.supermoney.in//mintLoan/mintloan/uploadFile";
        let formData = new FormData();
        formData.append("file", this.secondDocument);
        formData.append(
          "data",
          '{"custid":"407", "filetype":"OTHER", "filename":"' +
          this.secondDocument.name +
          '", "access": "PRIVATE"}'
        );
        formData.append(
          "msgHeader",
          '{ "loginId":"' +
          this.mobileNumber +
          '","consumerId":"414", "authToken":"' +
          localStorage.getItem("authtoken") +
          '","channelType":"M","deviceId":"SwiggyLoans","source":"WEB"}'
        );

        axios
          .post(url, formData, {
            headers: {
              "Content-Type": "multipart/form-data"
            }
          })
          .then(response => {
            const JSONData = response.data;
            var successFlag = JSONData.data.successFlag;

            if (successFlag === true) {
              this.invoiceUrlSecond = JSONData.data.fileLocation;
              this.frontPubLocationSecond = JSONData.data.pubFileLocation;

              this.uploadStatusSecond();
            } else {
              if (JSONData.header.hostStatus === "E") {
                this.errorAadharImg = true;

                this.errorAadharImgText = JSONData.header.error.errorDesc;
                if (JSONData.header.error.errorDesc === "") {
                  this.errorAadharImgText =
                    JSONData.data.errorDetails.errorDesc;
                }
              } else {
                this.errorAadharImg = true;
                this.errorAadharImgText =
                  JSONData.data.errorDetails[0].errorDesc;
              }
              this.$store.commit("routeChange", "end");
            }
            // this.$store.commit("routeChange", "end");
          })
          .catch(function (error) {
            console.log(error);
          });
      } else {
        this.uploadAddressFlag = true;
        this.uploadAddressMessage = "Please select file";
      }
    },

    uploadStatusSecond() {
      var self = this;
      self.$store.commit("routeChange", "start");
      console.log("this is pan no", self.panno);
      const instance = axios.create({
        baseURL: "https://uatgateway.supermoney.in/mintLoan/mintloan/",
        headers: { "content-type": "application/json" }
      });

      //  var url = 'http://13.126.28.53:8080/MintReliance/MintReliance/kycCheck'
      var data = {
        profileId: self.profileId,
        documentDetails: [
          {
            docSeqId: "",
            docStatus: "N",
            docTypeId: "126",
            docURL: self.invoiceUrlSecond,
            applicationId: this.$route.query.applicationId
          }
        ]
      };
      var timestamp = Math.round(+new Date() / 1000);
      var msgHeader = {
        authToken: localStorage.getItem("authtoken"), //dynamic
        loginId: self.mobileNumber,
        channelType: "M",
        consumerId: "414",
        deviceId: "SwiggyLoans",
        source: "webDirect"
      };
      var deviceFPmsgHeader = {
        clientIPAddress: "192.168.0.122",
        connectionMode: "WIFI",
        country: "United States",
        deviceManufacturer: "Xiaomi",
        deviceModelNo: "Mi A2",
        dualSim: false,
        imeiNo: "09d9212a07553637",
        latitude: "",
        longitude: "",
        nwProvider: "xxxxxxxx",
        osName: "Android",
        osVersion: 28,
        timezone: "Asia/Kolkata",
        versionCode: "58",
        versionName: "5.5.1"
      };

      var employeeDetails = { data, deviceFPmsgHeader, msgHeader };
      instance
        .post("kycDocumentUploadStatus", employeeDetails)

        .then(function (response) {
          console.log(response);
          const JSONData = response.data;
          if (JSONData.data.successFlag == true) {
            self.updateInvoice();
          }
          self.$store.commit("routeChange", "end");

          self.progress = false;
        })
        .catch(error => {
          self.errorText = "Network Error";
          console.log("display Error" + error);
          self.$store.commit("routeChange", "end");
        });
    },
    updateInvoice() {
      var self = this;
      self.$store.commit("routeChange", "start");
      const instance = axios.create({
        baseURL:
          "https://uatgateway.supermoney.in/invoice-finance-services/invoice-services/finance/invoices/",

        headers: { "content-type": "application/json" }
      });
      var data = {
        invoiceId: self.invoiceIdSelected,
        invoiceUrl: self.frontPubLocationSecond
      };
      instance
        .post("update", data)

        .then(function (response) {
          console.log(response);
          const JSONData = response.data;

          if (JSONData.status === true) {
            self.listLoan();
          } else {
            self.addInvoiceFailureFlag = true;
            self.invoiceAddError = JSONData.errorDetails.errorMessage;
            self.$store.commit("routeChange", "end");
          }
          self.$store.commit("routeChange", "end");
        })
        .catch(function (error) {
          if (error.response) {
            console.log(error.response.data);
            console.log(error.response.status);
            console.log(error.response.headers);
            self.GeneralError = true;
            self.errorMessage = error.response.data.errors[0];
            self.$store.commit("routeChange", "end");
          }
          self.$store.commit("routeChange", "end");
        });
    },
    finalUploadInvoice() {
      console.log("1");
      if (this.invoiceNumber != null && this.invoiceNumber.length > 0) {
        console.log("2");
        if (this.date != null && this.date.length > 0) {
          console.log("3");
          if (this.dueDate != null && this.dueDate.length > 0) {
            console.log("4");
            if (
              this.invoiceAmount != null &&
              this.invoiceAmount.length > 0 &&
              this.invoiceAmount > 0
            ) {
              console.log("5");

              console.log("6");
              let self = this;
              self.$store.commit("routeChange", "start");
              console.log(self.date);
              let url =
                "https://uatgateway.supermoney.in/mintLoan/mintloan/invoiceFinancing";
              let data = {
                invoiceType: "createInvoice",
                request: {
                  companyName: self.companyName,
                  supplierId: self.supplier.supplierId,
                  borrowerId: self.borrowerId,
                  purchaseOrderNumber: self.invoiceNumber,
                  invoiceAmount: self.invoiceAmount,
                  invoiceDate: this.$moment(self.date).format("YYYY-MM-DD"),
                  invoiceDueDate: this.$moment(self.dueDate).format(
                    "YYYY-MM-DD"
                  ),
                  submittedBy: "app",
                  invoiceUrl: self.frontPubLocation,
                  byBorrower: true,
                  isPartialDisbursalApplicable:
                    self.program.isParialDisbursalApplicable
                }
              };
              let timestamp = Math.round(+new Date() / 1000);
              let msgHeader = {
                authToken: localStorage.getItem("authtoken"), //dynamic
                loginId: self.mobileNumber,
                channelType: "M",
                consumerId: "414",
                deviceId: "androidDirect",
                source: "webDirect"
              };
              let deviceFPmsgHeader = {
                clientIPAddress: "192.168.0.122",
                connectionMode: "WIFI",
                country: "United States",
                deviceManufacturer: "Xiaomi",
                deviceModelNo: "Mi A2",
                dualSim: false,
                imeiNo: "09d9212a07553637",
                latitude: "",
                longitude: "",
                nwProvider: "xxxxxxxx",
                osName: "Android",
                osVersion: 28,
                timezone: "Asia/Kolkata",
                versionCode: "58",
                versionName: "5.5.1"
              };

              let employeeDetails = { data, deviceFPmsgHeader, msgHeader };
              axios
                .post(url, employeeDetails, {
                  headers: {
                    "content-type": "application/json"
                  }
                })
                .then(function (response) {
                  self.$bvModal.hide("modal-center-invoice");
                  console.log(response);
                  const JSONData = response.data;

                  let successFlag = JSONData.data.successFlag;
                  // self.authToken = JSONData.header.authToken

                  if (successFlag === true) {
                    //self.getInvoiceLoan(JSONData.data.details.invoiceId);
                    self.listLoan();
                    self.addInvoiceSuccessFlag = true;
                    self.invoiceID = JSONData.data.details.invoiceId;

                    self.$store.commit("routeChange", "end");
                  } else {
                    self.addInvoiceFailureFlag = true;
                    self.invoiceAddError = JSONData.data.details.errors[0];

                    self.$store.commit("routeChange", "end");
                  }
                })
                .catch(function (error) {
                  // handle error
                  console.log("display  ==" + error);
                })
                .finally(function () {
                  // always executed
                });
            } else {
              this.invoiceAmountError =
                "Enter Invoice Amount. Please try again";
            }
          } else {
            this.dueDateError = "Select Invoice Due Date";
          }
        } else {
          this.dateError = "Select Invoice Date";
        }
      } else {
        this.invoiceNumberError = "Enter Invoice Number";
      }
    },
    creditLimit() {
      let self = this;
      self.$store.commit("routeChange", "start");
      let custId = Number(self.$route.query.data);
      const instance = axios.create({
        baseURL:
          "https://uatgateway.supermoney.in/credit-analytics-service/application/creditlimit/",
        headers: { "content-type": "application/json" }
      });
      let data = {
        applicationId: Number(self.$route.query.applicationId),
        customerId: self.$route.query.data
      };

      instance
        .post("get", data)
        .then(function (response) {
          const JSONData = response.data;

          // self.approvedLimit =
          //   JSONData.data.loanLimitDetails[0].approvedLimit;
          self.totalLimit = JSONData.totalCreditLimit;
          self.utilizedLimit = JSONData.utilizedCreditLimit;
          self.availableLimit = JSONData.unutilizedCreditLimit;
          self.avilablePercentage = parseInt(
            (self.utilizedLimit / self.totalLimit) * 100
          );
          // if (JSONData.data.loanLimitDetails[0].utilisedLimit > 0) {
          //   self.utilizationCard = false;
          //   self.invoiceCard = true;

          // } else {
          //   self.sheet = true;

          //   self.utilizationCard = true;
          // }
          //self.DashboardApi();
          // self.unutilisedLimit =
          //   JSONData.data.loanLimitDetails[0].unutilisedLimit;

          self.$store.commit("routeChange", "end");
        })
        .catch(function (error) {
          // handle error
          console.log("display  ==" + error);
          //self.DashboardApi();
          self.$store.commit("routeChange", "end");
        })
        .finally(function () {
          // always executed
        });
    },
    getInvoiceLoan(approvedAmount, item, index) {
      let self = this;
      console.log(approvedAmount.toString().length > 0);
      console.log("1==" + Number(approvedAmount) >= 500);
      console.log(
        approvedAmount.length >
        "2==" + Number(approvedAmount) <=
        Number(item.invoiceAmount)
      );
      console.log(
        approvedAmount.length >
        Number(approvedAmount) <=
        Number(this.availableLimit)
      );
      if (
        approvedAmount.toString().length > 0 &&
        Number(approvedAmount) <= Number(item.invoiceAmount) &&
        Number(approvedAmount) <= Number(this.availableLimit)
      ) {
        const instance = axios.create({
          baseURL: "https://uatgateway.supermoney.in/loanService/",

          headers: { "content-type": "application/json" }
        });
        let data = {
          batch_fail: true,
          loan_details: [
            {
              created_by: self.$store.getters.loginId,
              customer_id: Number(self.$route.query.data),
              loan_product_id: "" + self.loanID + "",
              application_id: Number(self.$route.query.applicationId),
              interest_rate: Number(
                self.financePlan.financePlanDetails.interestRate
              ),
              interest_rate_per_annum: Number(
                self.financePlan.financePlanDetails.interestRatePerAnnum
              ),
              related_id: Number(item.invoiceId),
              amount: Number(approvedAmount),
              term_frequency: Number(self.termFrequency),
              lender_account_id: self.razorpayAccountId
            }
          ]
        };

        instance
          .post("CreateLoanV2", data)
          .then(function (response) {
            const JSONData = response.data;
            console.log(response);

            self.supplier = null;
            self.invoiceNumber = "";
            self.invoiceAmount = "";
            self.date = null;
            self.dueDate = null;
            self.invoiceImageUploadUrl = null;
            if (JSONData.error_code.length == 0) {
              if (item.approvedInvoiceAmount.length == 0) {
                self.updateInvoiceAmount(approvedAmount, item.invoiceId);
              } else {
                self.kycDocuments();
              }
              self.$store.commit("routeChange", "end");
            } else {
              self.$store.commit("routeChange", "end");
              self.alert = true;
              self.alertMessage = JSONData.error_code;
            }
          })
          .catch(function (error) {
            // handle error
            console.log("display  ==" + error);
            self.$store.commit("routeChange", "end");
          })
          .finally(function () {
            // always executed
          });
      } else {
        this.approveInvoiceFailureFlag = !this.approveInvoiceFailureFlag;
        if (approvedAmount.length == 0) {
          this.approveInvoiceAddError = "Enter Approved Invoice Amount";
        } else if (Number(approvedAmount) < 500) {
          this.approveInvoiceAddError = "Minimum Amount is 500";
        } else if (Number(approvedAmount) > Number(item.invoiceAmount)) {
          this.approveInvoiceAddError =
            "Maximum Amount is " + item.invoiceAmount;
        } else {
          this.approveInvoiceAddError =
            "Enter less amount available limit is " + this.availableLimit;
        }
      }
    },
    updateInvoiceAmount(Amount, invoiceIdSelected) {
      var self = this;
      self.$store.commit("routeChange", "start");
      const instance = axios.create({
        baseURL:
          "https://uatgateway.supermoney.in/invoice-finance-services/invoice-services/finance/invoices/",

        headers: { "content-type": "application/json" }
      });
      var data = {
        invoiceId: invoiceIdSelected,
        approvedInvoiceAmount: Amount,
        updateLoanDetails: false
      };
      instance
        .post("update", data)

        .then(function (response) {
          console.log(response);
          const JSONData = response.data;

          if (JSONData.status === true) {
            self.kycDocuments();
          } else {
            self.addInvoiceFailureFlag = true;
            self.invoiceAddError = JSONData.errorDetails.errorMessage;
            self.$store.commit("routeChange", "end");
          }
          self.$store.commit("routeChange", "end");
        })
        .catch(function (error) {
          if (error.response) {
            console.log(error.response.data);
            console.log(error.response.status);
            console.log(error.response.headers);
            self.GeneralError = true;
            self.errorMessage = error.response.data.errors[0];
            self.$store.commit("routeChange", "end");
          }
          self.$store.commit("routeChange", "end");
        });
    },
    updateInvoiceLoanDetails(invoiceIdSelected) {
      var self = this;
      self.$store.commit("routeChange", "start");
      const instance = axios.create({
        baseURL:
          "https://uatgateway.supermoney.in/invoice-finance-services/invoice-services/finance/invoices/",

        headers: { "content-type": "application/json" }
      });
      var data = {
        invoiceId: invoiceIdSelected,
        updateLoanDetails: true
      };
      instance
        .post("update", data)

        .then(function (response) {
          console.log(response);
          const JSONData = response.data;

          if (JSONData.status === true) {
            self.kycDocuments();
          } else {
            self.addInvoiceFailureFlag = true;
            self.invoiceAddError = JSONData.errorDetails.errorMessage;
            self.$store.commit("routeChange", "end");
          }
          self.$store.commit("routeChange", "end");
        })
        .catch(function (error) {
          if (error.response) {
            console.log(error.response.data);
            console.log(error.response.status);
            console.log(error.response.headers);
            self.GeneralError = true;
            self.errorMessage = error.response.data.errors[0];
            self.$store.commit("routeChange", "end");
          }
          self.$store.commit("routeChange", "end");
        });
    },
    kycDocuments() {
      console.log("this is third tab");

      this.$store.commit("routeChange", "start");
      var timestamp = Math.round(+new Date() / 1000);

      var data = {
        customerID: this.$route.query.data
      };
      var msgHeader = {
        authToken: localStorage.getItem("authtoken"), //dynamic
        authLoginID: this.$store.getters.loginId,
        timestamp: timestamp,
        ipAddress: ""
      };
      var employeeKycDetails = { data, msgHeader };
      axios
        .post("mlCustomerDetails", employeeKycDetails)
        .then(response => {
          const JSONData = response.data;
          if (JSONData.data.error == 0) {
            this.dataAvailable = true;
            // this.getKycVerificationID();

            this.mobileNumber = JSONData.data.custCredentials.loginID;
            this.customerProfile();

            this.$store.commit("routeChange", "end");
          } else {
            this.errorMessage = JSONData.data.message;
            this.GeneralError = true;
            this.dataAvailable = false;
          }
          this.$store.commit("routeChange", "end");
        })
        .catch(error => {
          this.errorText = error;
          this.dataAvailable = false;
          console.log("display Error" + this.errorText);
          this.$store.commit("routeChange", "end");
        });
    },
    customerProfile() {
      this.$store.commit("routeChange", "start");
      let self = this;

      let url =
        "https://uatgateway.supermoney.in/mintLoan/mintloan/customerProfile";
      let request = {
        applicationId: self.$route.query.applicationId,
        loginId: self.mobileNumber
      };

      axios
        .post(url, request, {
          headers: {
            "content-type": "application/json"
          }
        })
        .then(function (response) {
          self.$store.commit("routeChange", "end");
          const JSONData = response.data;
          if (JSONData.errorMessage === "") {
            let name = JSONData.name;
            self.companyName = JSONData.companyName;
            self.borrowerId = JSONData.borrowerId;
            self.customerId = JSONData.customerId;
            self.listLoan();
            self.getSuppliers();
          } else {
            self.alert = true;
            self.alertMessage = JSONData.errorMessage;
          }
        })
        .catch(function (error) {
          // handle error
          console.log("display  ==" + error);
        })
        .finally(function () {
          //self.$store.commit("routeChange", "end");
        });
    },
    getSuppliers() {
      let self = this;
      self.$store.commit("routeChange", "start");

      let plussym = "+91";
      let finalLogin = plussym + self.loginId;

      let url =
        "https://uatgateway.supermoney.in/invoice-finance-services/invoice-services/borrower/get";
      let data = {
        borrowerId: self.borrowerId
      };
      let timestamp = Math.round(+new Date() / 1000);

      axios
        .post(url, data, {
          headers: {
            "content-type": "application/json"
          }
        })
        .then(function (response) {
          const JSONData = response.data;
          let successFlag = JSONData.borrowerId;

          if (successFlag != "") {
            //self.fileUploaded = true
            self.suppliersListAssociated = JSONData.suppliers;
            console.log(self.suppliersListAssociated);

            self.$store.commit("routeChange", "end");
          } else {
            let errors = JSONData.data.error[0].errorMessage;
            self.alertMessage = errors;
            self.alert = true;
            self.$store.commit("routeChange", "end");
          }
        })
        .catch(function (error) {
          // handle error
          console.log("display  ==" + error);
          self.$store.commit("routeChange", "end");
        })
        .finally(function () {
          // always executed
        });
    },
    DashboardApi() {
      // let plussym = "+91"
      // let finalLogin = plussym + self.loginId

      let self = this;
      self.$store.commit("routeChange", "start");
      self.activeLoans = [];
      self.closedLoans = [];
      self.pendingLoans = [];
      self.rejectedLoans = [];
      self.repaidLoans = [];
      self.preClosedLoans = [];

      let url =
        "https://uatgateway.supermoney.in/loanService/LoanDetailsWithRepayment";
      let data = {
        customerId: Number(self.$route.query.data)
      };

      axios
        .post(url, data, {
          headers: {
            "content-type": "application/json"
          }
        })
        .then(function (response) {
          const JSONData = response.data;
          if (JSONData.error_description === "") {
            self.customerLoanDetails = JSONData.customerLoanDetails;
            for (var i = 0; i < self.customerLoanDetails.length; i++) {
              if (self.customerLoanDetails[i].status === "ACTIVE") {
                self.activeLoans.push(self.customerLoanDetails[i]);
              }
              // else if(self.customerLoanDetails[i].status ==='CLOSED')
              // {
              //   self.closedLoans.push(self.customerLoanDetails[i])
              // }
              else if (self.customerLoanDetails[i].status === "PENDING") {
                self.pendingLoans.push(self.customerLoanDetails[i]);
              } else if (self.customerLoanDetails[i].status === "REPAID") {
                self.repaidLoans.push(self.customerLoanDetails[i]);
              } else if (self.customerLoanDetails[i].status === "REJECTED") {
                self.rejectedLoans.push(self.customerLoanDetails[i]);
              } else if (
                self.customerLoanDetails[i].status === "PRE_DISBURSEMENT_CLOSED"
              ) {
                self.preClosedLoans.push(self.customerLoanDetails[i]);
              }
            }

            self.$store.commit("routeChange", "end");

            self.changeActive(this.selectedButtonN);
          } else {
            self.$store.commit("routeChange", "end");
          }
        })
        .catch(function (error) {
          // handle error
          // self.alert = true;
          // self.alertMessage = "Server Connection Failed";
          self.$store.commit("routeChange", "end");
        })
        .finally(function () {
          // always executed
        });
    },
    showToast(variant, position) {
      this.$toast(
        {
          component: ToastificationContent,
          props: {
            title: "Notification",
            icon: "InfoIcon",
            text: "I do not think that word means what you think it means.",
            variant
          }
        },
        {
          position
        }
      );
    },
    hideModal() {
      this.$refs["modal-center-invoice"].hide();
      //this.showToast("primary", "bottom-right");
    },
    fetchProgram(value) {
      this.$store.commit("routeChange", "start");
      let self = this;
      let data = {
        borrowerType: "",
        company: "",
        onboardingPartner: "",
        requestId: value
      };
      let url =
        "https://uatgateway.supermoney.in/supermoney-service/program/get";
      axios
        .post(url, data, {
          headers: {
            "content-type": "application/json"
          }
        })
        .then(function (response) {
          const JSONData = response.data;
          self.programDetails = JSONData.getProgramRespList[0];
          self.fetchFinancingList();
        })
        .catch(function (error) {
          // handle error
          console.log("display  ==" + error);
        })
        .finally(function () {
          // always executed
          self.$store.commit("routeChange", "end");
        });
    },
    fetchFinanceSupplierMapping() {
      this.$store.commit("routeChange", "start");
      let self = this;
      const instance = axios.create({
        baseURL:
          "https://uatgateway.supermoney.in/supermoney-service/supplier/financingPlan/",

        headers: { "content-type": "application/json" }
      });

      let request = {
        supplierId: 299
      };

      instance
        .post("get", request)
        .then(function (response) {
          self.$store.commit("routeChange", "end");
          console.log(response);
          const JSONData = response.data;
          if (JSONData.data.length > 0) {
            self.finacePlaList = JSONData.data;
            self.finacePlaList.forEach((item, index) => {
              self.fetchFinancePlan(item.financingPlanId, index);
            });
          }
        })
        .catch(function (error) {
          // handle error
          console.log("display  ==" + error);
        })
        .finally(function () {
          //self.$store.commit("routeChange", "end");
        });
    },
    fetchFinancePlan(financePlan, index) {
      this.$store.commit("routeChange", "start");
      let self = this;

      const instance = axios.create({
        baseURL:
          "https://uatgateway.supermoney.in/supermoney-service/financeplan/",

        headers: { "content-type": "application/json" }
      });
      let request = {
        fianancingPlanId: financePlan
      };

      instance
        .post("get", request)
        .then(function (response) {
          self.$store.commit("routeChange", "end");
          console.log(response);
          const JSONData = response.data;
          console.log(
            "===",
            JSONData.getFinancePlanRespList[0].financingPlanName
          );
          self.$set(
            self.finacePlaList[index],
            "planName",
            JSONData.getFinancePlanRespList[0].financingPlanName
          );
        })
        .catch(function (error) {
          // handle error
          console.log("display  ==" + error);
        })
        .finally(function () {
          self.$store.commit("routeChange", "end");
        });
    }
  },
  computed: {},
  watch: {}
};
</script>

<style>
h5:hover {
  overflow: visible;

  white-space: normal;
  height: auto;
}

h5 {
  white-space: nowrap;
  font-size: 13px;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 120px;
  cursor: pointer;
  word-break: break-all;
}

.text-left {
  text-align: left;
}

.buttonActiveNew {
  border-bottom: 5px solid #7367f0;
  color: #7367f0;
}
</style>
<style lang="scss">
@import "../../@core/scss/vue/libs/vue-flatpicker.scss";
</style>
<style lang="scss">
#financing-plan>div {
  border: 0px solid rgba(60, 60, 60, 0.26);
}

#financing-plan>div>div>input {
  font-size: 12px;
}

div.isDefault>.custom-control-label::after {
  left: 0px !important;
}

div.isDefault>.custom-control-label::before {
  left: 0px !important;
}

#modal-center-invoice___BV_modal_header_ {
  display: none;
}

#modal-center-invoice>div {
  min-width: 900px;
}

.theme--light.v-file-input .v-file-input__text--placeholder {
  color: #ced4da;
  font-size: 14px;
}

.v-input__slot {
  border-color: #ced4da !important;
  border: 0.5px !important;
  font-size: 14px;
}

.hr5 {
  border: 0;
  border-top: 1px solid #ebe9f1;
}

td {
  text-align: center;
}

tr {
  text-align: center;
}

#repayTable>th {
  text-align: left;
}

#invoiceDetailImage>canvas {
  width: 180px !important;
  height: 100px !important;
  margin: 0px;
}

.vs__selected {
  background-color: #7367f0;
  border: 0 solid rgba(60, 60, 60, 0.26);
  border-radius: 0.357rem;
  margin: 4px 2px 0px 2px;
  padding: 0 0.25em;
}

.v-select:not(.vs--single) .vs__selected>button>span>svg {
  color: #fff;
  stroke: #fff;
  opacity: 1;
}

.v-select:not(.vs--single) .vs__selected {
  color: #fff;
}

.v-select:not(.vs--single) .vs__selected {
  margin: 5px 2px 2px 5px;
}

.v-select:not(.vs--single) .vs__selected {
  border-radius: 3px;
  padding: 0 0.6em;
}

.vs__selected-options {
  clear: both;
  display: inline-block;
  overflow: auto;
  white-space: nowrap;
}

.vs__selected-options::-webkit-scrollbar {
  display: none;
}

.vs__selected {
  display: inline-flex;
}

.vs__dropdown-option--selected.vs__dropdown-option--highlight {
  color: #fff !important;
  background-color: #7367f0 !important;
}

.vs__dropdown-option--selected {
  background-color: #7367f0 !important;
  color: #fff !important;
  position: relative;
}

.vs__dropdown-option--highlight {
  color: #7367f0;
  background: rgba(115, 103, 240, 0.12);
}

.vs__dropdown-option {
  padding: 7px 20px;
}

.mt-1 {
  margin-top: 0.25rem !important;
}

.vs__dropdown-option--selected::after {
  content: "";
  height: 1.1rem;
  width: 1.1rem;
  display: inline-block;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 20px;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%23fff' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-check'%3E%3Cpolyline points='20 6 9 17 4 12'%3E%3C/polyline%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: center;
  background-size: 1.1rem;
}

.vs__search {
  width: auto;
}

#alertShowNew .con-x.vs-alert--close {
  background: none;
  color: #ea5455;
  margin-top: 10px;
}
</style>
